var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1344_28929)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1344_28929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1344_28929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 12C17.625 11.4798 17.5311 10.9856 17.3983 10.507L18.7924 9.70223L17.3861 7.26652L16.0072 8.06269C15.304 7.34705 14.4063 6.8347 13.4063 6.57473V4.96875H10.5938V6.57473C9.59373 6.8347 8.69608 7.34705 7.99286 8.06269L6.61389 7.26652L5.20764 9.70223L6.6017 10.507C6.46891 10.9856 6.37502 11.4798 6.37502 12C6.37502 12.5202 6.46891 13.0144 6.6017 13.493L5.20764 14.2978L6.61389 16.7335L7.99286 15.9373C8.69608 16.653 9.59373 17.1653 10.5938 17.4253V19.0312H13.4063V17.4253C14.4063 17.1653 15.304 16.653 16.0072 15.9373L17.3861 16.7335L18.7924 14.2978L17.3983 13.493C17.5311 13.0144 17.625 12.5202 17.625 12Z",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.8125C10.4489 14.8125 9.1875 13.5511 9.1875 12C9.1875 10.4489 10.4489 9.1875 12 9.1875C13.5511 9.1875 14.8125 10.4489 14.8125 12C14.8125 13.5511 13.5511 14.8125 12 14.8125Z",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57078 16.2188C1.04161 14.9153 0.703125 13.4911 0.703125 12C0.703125 5.79685 5.79684 0.703127 12 0.703127C15.5531 0.703127 18.8861 2.45892 20.9493 5.03944",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4292 7.78125C22.9584 9.08466 23.2969 10.5089 23.2969 12C23.2969 18.2032 18.2031 23.2969 12 23.2969C8.44686 23.2969 5.11386 21.5411 3.05066 18.9606",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.955 2.05632L20.9493 5.03944L17.9662 4.04504",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03378 19.9549L3.05066 18.9606L4.04502 21.9437",
    stroke: "#9094A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_28929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperation);
export default __webpack_public_path__ + "static/media/Operation.f985180d441b32218e35240e3f474087.svg";
export { ForwardRef as ReactComponent };